import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
Vue.use(Router)
export default new Router({
	mode:'history',
	// base: process.env.NODE_ENV === 'production' ? '/bc_cd_cdaee' : '/',
	routes: [
		{
			path: '/',
			name: 'home',
			component: () => import('./views/Home.vue'),
			// redirect: '/project-info',
			//根据返回的菜单权限，显示第一个
			redirect: to =>{
				let i = store.state.user.permission[0].router;
                return '/'+i;
            },
			children: [
				{path: '/project-info',component: () => import('./views/ProjectInfo/index.vue'),name: '首页'},
				{path: '/project-info2',component: () => import('./views/ProjectInfo2/index.vue'),name: '首页2'},
				{path: '/noevent',component: () => import('./views/NoEvent/index.vue'),name: '异常界面'},
				{path: '/noeventxq',component: () => import('./views/NoEventXq/index.vue'),name: '异常界面详情页面'},
				{path: '/AlarmRules',component: () => import('./views/AlarmRules/index.vue'),name: '报警规则界面'},
				{path: '/chain',component: () => import('./views/Chain/index.vue'),name: '链'},
				{path: '/log', component: () => import('./views/Log/index.vue'), name: '日志',meta: {requireAuth: true}},
				{path: '/logmessage', component: () => import('./views/LogMessage/index.vue'), name: '日志上下文'},
				{path: '/thread',component: () => import('./views/Thread/index.vue'),name: '线程'},
				{path: '/option', component: () => import('./views/Option/index.vue'), name: '运行情况'},
				{path: '/weather', component: () => import('./views/Weather/index.vue'), name: '服务器'},
				{path: '/cube', component: () => import('./views/Cube/index.vue'), name: 'node网络'},
				{path: '/authority-test', component: () => import('./views/AuthorityTest/index.vue'), name: '业务'},
				{path: '/chainthing', component: () => import('./views/ChainThing/index.vue'), name: '详细节点信息'},
				{path: '/chainprocess', component: () => import('./views/ChainProcess/index.vue'), name: '详细节点信息(三级)'},
				{path: '/dseed', component: () => import('./views/Dseed/index.vue'), name: 'D3页面'},
				{path: '/problem', component: () => import('./views/Problem/index.vue'), name: '问题报告首页'},
				{path: '/problembg', component: () => import('./views/ProblemBg/index.vue'), name: '问题报告首页'},
				{path: '/development', component: () => import('./views/Development/index.vue'), name: '开发参数设置'},
				{path: '/problemxq', component: () => import('./views/ProblemXq/index.vue'), name: '问题报告详情'},
				{path: '/JzRember', component: () => import('./views/JzRember/index.vue'), name: '基准报告'},
				{path: '/ProblemList', component: () => import('./views/ProblemList/index.vue'), name: '问题清单'},
				{path: '/TechnologyList', component: () => import('./views/TechnologyList/index.vue'), name: '技术路线'},
				{path: '/EverbrightChain', component: () => import('./views/EverbrightChain/index.vue'), name: '光大链'},
				{path: '/userManager', component: () => import('./views/UserManager/index.vue'), name: '用户管理'},
				{path: '/roleManager', component: () => import('./views/RoleManager/index.vue'), name: '角色管理'},
			]
		},
		{//登录
			path: '/login',
			name: 'login',
			component: () => import('./views/Login.vue')
		},
		{//注册
			path: '/register',
			name: 'register',
			component: () => import('./views/Register.vue')
		},
		{//修改密码
			path: '/modifypassword',
			name: 'modifypassword',
			component: () => import('./views/Modifypassword.vue')
		},

	]
})

// function menuShow () {
// 	var navData = this.$store.getters.getPermission;
// 	console.log(navData);
// 	return navData;
//   }